import { TechDimensions } from "../dimensions/TechDimensions";
import { GeoDimensions } from "../dimensions/GeoDimensions";
import { SessionDimensions } from "../dimensions//SessionDimensions";
import { UserDimensions } from "../dimensions/UserDimensions";
import { getCookies, getLang } from "../../Helpers/functions";
import { ActionDimensions } from "../dimensions/ActionDimensions";
import { defaultOptions, setCookie } from "../../Helpers";
import Cookies from "js-cookie";

const useLogging = ()=>{
    const DEFAULT_VALUE = 'NA';

    const urlParams = new URLSearchParams(window.location.search)
    const sessionFunnelSource = urlParams.get('SessionFunnelSource')
    const sessionFunnelPointOfEntry = Cookies.get('sessionFunnelPointOfEntry');
    if(sessionFunnelPointOfEntry)
    {
        ActionDimensions.getInstance().sessionFunnelPointOfEntry = sessionFunnelPointOfEntry;
    }
    if(sessionFunnelSource)
    {
        ActionDimensions.getInstance().sessionFunnelSource = sessionFunnelSource;
        setCookie('session_funnel_source', sessionFunnelSource, defaultOptions);
    }
    
    if(getCookies().ecountry)
    {
        GeoDimensions.getInstance().geoAppCountry = getCookies().ecountry;
    }
    if(getCookies().userInfo && getCookies().userInfo.id)
    {   
        const userId = getCookies().userInfo.id.toString();
        UserDimensions.getInstance().userMemberId = userId;
    }
    else
    {
        // member cookie is gone: do not keep logging the previous member
        UserDimensions.getInstance().userMemberId = DEFAULT_VALUE;
    }

    UserDimensions.getInstance().userTrackingId = (getCookies() && getCookies().device_uuid && getCookies().device_uuid.length > 0) ? getCookies().device_uuid : DEFAULT_VALUE;

    TechDimensions.getInstance().language = getLang() ?? DEFAULT_VALUE
    TechDimensions.getInstance().version = process.env.REACT_APP_VERSION ?? DEFAULT_VALUE;
    
    SessionDimensions.getInstance().sessionId = getCookies().tgtTicket ? getCookies().tgtTicket : DEFAULT_VALUE;

}

export {useLogging}